import useAxios from 'hooks/useAxios';

const clearCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
};

export const clearAuthSession = () => {
  clearCookie('access_token');
  clearCookie('connect.sid');
};

export const login = async (email, password) => {
  const api = useAxios();
  return await api.post('/auth/login', { email, password });
};

export const getCurrentUser = async () => {
  const api = useAxios();
  return (await api.get('/users/me')).data;
};

export const logout = async () => {
  const api = useAxios();
  try {
    await api.post('/admin/auth/logout');
  } catch (err) {
    console.warn('Logout endpoint failed, clearing local session instead.', err);
  } finally {
    clearAuthSession();
  }
};
